
(function () {
  if (customElements.get('silo-alexa-gallery')) return;

  const ANIM = 300; // matches the CSS expand transition

  class SiloAlexaGallery extends HTMLElement {
    connectedCallback() {
      this.blocks = Array.from(this.querySelectorAll('[data-image-block]'));
      if (!this.blocks.length) return;

      this.activeIndex = 0;
      this.timer = null;
      this.controller = new AbortController();
      const { signal } = this.controller;

      this.blocks.forEach((block, i) => {
        block.addEventListener('click', () => this.activate(i), { signal });
      });

      // Reset to the first panel whenever the gallery scrolls back into view.
      this.io = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && this.activeIndex !== 0) this.activate(0);
        }
      }, { threshold: 0.1 });
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.io) this.io.disconnect();
      if (this.timer) clearTimeout(this.timer);
    }

    activate(index) {
      if (index === this.activeIndex) return;
      if (this.timer) clearTimeout(this.timer);

      this.blocks.forEach((block, i) => {
        const isActive = i === index;
        const normal = block.querySelector('.normal-image');
        const expanded = block.querySelector('.expanded-image');
        const desc = block.querySelector('.image-description');

        block.classList.toggle('active', isActive);
        block.classList.toggle('t-flex-[2]', isActive);
        block.classList.toggle('t-flex-1', !isActive);

        if (normal && expanded) {
          normal.classList.toggle('t-hidden', isActive);
          expanded.classList.toggle('t-hidden', !isActive);
        }

        if (!desc) return;
        if (isActive) {
          // Reveal once the panel has finished expanding.
          this.timer = setTimeout(() => {
            desc.classList.remove('t-opacity-0', 't-max-h-0');
            desc.classList.add('t-opacity-100', 't-max-h-20');
          }, ANIM);
        } else {
          desc.classList.add('t-opacity-0', 't-max-h-0');
          desc.classList.remove('t-opacity-100', 't-max-h-20');
        }
      });

      this.activeIndex = index;
    }
  }

  customElements.define('silo-alexa-gallery', SiloAlexaGallery);
})();
